export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_13-de0c4bd66cd8b43bc501e3acc902c51f.jpg";